<div class="form-group-query">
    <div [style]="props['labelstyle']">
        <label>{{to.label}}</label>
    </div>
    <div style="margin-left:10px">
        <input (click)="manageCheck();$event.preventDefault();" [checked]="isChecked" type="checkbox" />
    </div>
    <div style="margin-left:10px;">
        <select  class="ml-5 form-control" (ngModelChange)="onInputChange()" (click)="loadLookup()" [style]="style" [formControl]="formControl" [formlyAttributes]="field" appRenderWidth>
            <option *ngFor="let result of results" [value]="result.code">{{ result.name }}</option>
        </select>
    </div>
</div>